//import {className} from './common.utils';
//import {logger} from './log.helper';

/**
 * Global change ID for immutable models, can be used to track them
 * in lists (track by x.change_id) since AngularJS does not support
 * tracking frozen objects by default.
 *
 * @type {number}
 */
let change_id = 0;

/**
 * An immutable model that should be used to prevent accidental
 * changing of data because of two-way bindings for example.
 *
 * When the model has been initialised, makeImmutable() should be
 * called to freeze it. To make changes, copy() should be called
 * and the new copy modified, then makeImmutable() to freeze the
 * new copy.
 *
 * To use, models should inherit from ImmutableModel and define
 * their own copy() function.
 */
class ImmutableModel {
  constructor() {
    this.change_id = ++change_id;

    // Uncomment the following and imports for in-depth logging.
    //logger().debug(`Instantiating new ${className(this)} with change ID ${this.change_id}`);
  }

  /**
   * Return a mutable copy of this object.
   */
  copy() {
    throw new Error('Copy not implemented!');
  }

  /**
   * Make this object immutable.
   * @returns {*} Reference to this object for chaining.
   */
  makeImmutable() {
    Object.freeze(this);
    return this;
  }
}

export default ImmutableModel;



// WEBPACK FOOTER //
// ./src/app/common/immutable.model.js